// redux/member-slices/specialist.slice.js
import { asyncThunkWrapper } from "../thunkHandler";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BASEURI, headers } from "../../utils/helper";

// Retrieve all specialists
export const handleRetrieveAllSpecialists = createAsyncThunk(
    "retrieveAll",
    async (data, thunkAPI) => {
        const params = {
            limit: data?.limit || null,
            search: data?.search || null,
            currentPage: data?.currentPage || null,
            specializationId: data?.specializationId || null,
            minPrice: data?.minPrice || null,
            maxPrice: data?.maxPrice || null,
            experience: data?.experience || null,
            language: data?.language || null,
            zip: data?.zip || null, 
            gender: data?.gender || null,

        };

        return asyncThunkWrapper(
            {
                params,
                method: "GET",
                headers: headers(),
                url: `${BASEURI}/public/specialist/appointmnet/retrieve-all`,
            },
            thunkAPI,
            {
                toast: false,
            }
        );
    }
);

// Retrieve specialist details with available slots
export const handleRetrieveSpecialistDetails = createAsyncThunk(
    "retrieveSingle",
    async ({ specialistId }, thunkAPI) => {
        return asyncThunkWrapper(
            {
                method: "GET",
                headers: headers(),
                url: `${BASEURI}/public/specialist/appointmnet/retrieve/deatails/${specialistId}`,
            },
            thunkAPI,
            {
                toast: false,
            }
        );
    }
);



// Retrieve all specializations (for filter dropdown)
export const handleRetrieveSpecializations = createAsyncThunk(
    "retrieveAll",
    async (data, thunkAPI) => {
        const params = {
            limit: data?.limit || 100,
            currentPage: 1,
        };

        return asyncThunkWrapper(
            {
                params,
                method: "GET",
                headers: headers(),
                url: `${BASEURI}/public/specialist/appointmnet/retrieve/specializations`,
            },
            thunkAPI,
            {
                toast: false,
            }
        );
    }
);